import Faq, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/faq';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Faq;
